export default {
  label: {
    xAxis: {
      title: 'Canal',
    },
    yAxis: {
      title: 'Respondentes',
    },
    bubble: {
      replier: 'Nome',
      channel: 'Canal',
      value: 'Valor',
      total: 'Total',
    },
  },
};
